import { DataBean } from "../DataBean";

export class THConstants extends DataBean {

  public async getTHConstantsCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getTHConstantsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteTHConstants(idthconstants: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteTHConstants_Number",
      [idthconstants]
    );
  }

  public async cleanSuppConstantsValues(idEmployee: number): Promise<any> {
    return this.getCustomService(
      "SupplierERP",
      "Boolean_cleanSuppConstantsValues_Number",
      [idEmployee]
    );
  }

  public async updateTHConstants(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.THConstants_updateTHConstants_com.orange.people.talent.bean.THConstants",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.THConstants",
        },
      ]
    );
  }
}
